export default "/_next/static/images/chas-schley-226c9b1957b76ad262e26557339941b2.png";